import { useQuery } from 'react-query';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum';
import { fetchCustomer } from 'src/services/napi';
import { HALF_HOUR } from '../../../../constant/time';
import { useNotification } from '../../../../providers/notificationsProvider';

const fetchCustomerData = async (customerId: string) => {
  const currentProject: any = getDataFromLocalStorage(LocalStorageKey.CURRENT_PROJECT);
  if (!currentProject) return;
  const { data }: any = await fetchCustomer(currentProject._id, customerId);
  return data;
};

export const useGetCustomerQuery = (customerId: string, projectId: string) => {
  const { notify } = useNotification();

  return useQuery([QueryKey.CUSTOMER, customerId, projectId], () => fetchCustomerData(customerId), {
    keepPreviousData: true,
    onError: () => {
      notify({ message: 'Error Loading data... Try again later', severity: 'error' });
    },
    staleTime: HALF_HOUR
  });
};
